import {media, tokens} from '@sail/ui';

export const MEDIA_QUERIES = {
  mediumWidth: media.down(tokens.viewport.medium),
  smallWidth: media.down(tokens.viewport.small),
  mediumWidthHeight: media.query('(max-width: 767px) and (max-height: 1000px)'),
};
